import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import actions from '../actions';
import ProjectSettingsModal from '../components/ProjectSettingsModal';

const mapStateToProps = (state) => {
  const { id, name, background, backgroundImage, isBackgroundImageUpdating } =
    selectors.selectCurrentProject(state);

  const currentProjectId = id;

  // const managers = selectors.selectManagersForCurrentProject(state);
  const roleAssignments = selectors.selectRoleAssignmentsForCurrentProject(state);
  // console.log('DOFQShiofiIHJ');
  // console.log('managers');
  // console.log(managers);
  console.log('roleAssignments');
  console.log(roleAssignments);
  const searchedUsers = selectors.selectSearchedUsers(state);
  const isSearchingUsers = selectors.selectIsSearchingUsers(state);
  const projectManagerRole = selectors.selectRoleByCode(state, 'project_manager');

  return {
    name,
    background,
    backgroundImage,
    isBackgroundImageUpdating,
    // managers,
    roleAssignments,
    projectManagerRole, // C'est le retour de l'ID du role Project Manager
    currentProjectId,
    searchedUsers,
    isSearchingUsers,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUpdate: entryActions.updateCurrentProject,
      onBackgroundImageUpdate: entryActions.updateCurrentProjectBackgroundImage,
      onDelete: entryActions.deleteCurrentProject,
      onRoleAssignmentCreate: entryActions.createUserRoleAssignment,
      onRoleAssignmentDelete: entryActions.deleteUserRoleAssignment,
      onClose: entryActions.closeModal,
      onSearchUsers: actions.searchUsers,
      onClearUserSearch: actions.clearUserSearch,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProjectSettingsModal);
